module.exports = __webpack_public_path__ + "img/6_92.9ca63613.png";